export default __webpack_public_path__ + "static/media/name_abla.4b64d32a.svg";